import { render, staticRenderFns } from "./BlackFridayFonts.vue?vue&type=template&id=a9420b10&"
import script from "./BlackFridayFonts.vue?vue&type=script&lang=js&"
export * from "./BlackFridayFonts.vue?vue&type=script&lang=js&"
import style0 from "./BlackFridayFonts.vue?vue&type=style&index=0&id=a9420b10&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports